import { AnyAction } from 'redux';

export function setSignUpFormDialogShowFlag(flag: boolean): AnyAction {
  return { type: 'SET_SIGNUP_FORM_DIALOG_SHOW_FLAG', payload: flag };
}

export function setSignUpFormSubmitResult(result: $TSFixMe): AnyAction {
  return { type: 'SET_SIGNUP_FORM_SUBMIT_RESULT', payload: result };
}
